/**
 * 認証 API の HTTP エラー応答をユーザー向けメッセージに変換する
 */
export function assertAuthApiOk(response, data, fallbackMessage = 'リクエストに失敗しました。') {
  if (response.status === 403) {
    throw new Error(data?.message || '許可されていないリクエスト元です。ページを再読み込みしてもう一度お試しください。');
  }
  if (response.status === 429) {
    throw new Error(data?.message || '送信回数の制限に達しました。しばらくしてからもう一度お試しください。');
  }
  if (!response.ok) {
    throw new Error(data?.message || data?.error || fallbackMessage);
  }
}
